export default function mapPropsToValues() {
  return {
    code: "",
    password: "",
    passwordConfirm: "",
  };
}
